<template>
    <div _tmplitem="22" class="dv-full-screen-container" :style="css">
        <div _tmplitem="22" style="position: absolute;--animation-linear:1;--animation-type:ease;width:1920px;height:1080px;background-color:rgb(43 44 45);" class="div-full-screen">
            <div _tmplitem="13" v-if="readDataPermission.img0kl8" class="bigitem img0kl8 " style="top: 142px; left: 910px;position: absolute; width: 100px; height: 100px; transform: translate(0px, 0px); z-index: 1012;pointer-events: auto;  ">
                <div _tmplitem="13" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <bigimg _tmplitem="1" :url="$staticUrl('/statics/2025/09/22/logo_20250922142150A097.png')" w="100" h="130" rotatetype="" rotatetime=""></bigimg>
                </div>
            </div>
            <div _tmplitem="22" v-if="readDataPermission.titletasx" class="bigitem titletasx " style="top: 570px; left: 860px;position: absolute; width: 100px; height: 20px; transform: translate(0px, 0px); z-index: 1011;pointer-events: auto;  ">
                <div _tmplitem="22" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:12px ;color:#4DBAC9 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <titlecontrol _tmplitem="11"  @click="readDataPermission.imgydk2 = !readDataPermission.imgydk2" ref="titletasx" :w="100" :h="20" :val="fromData.titletasx" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:12px ;color:#4DBAC9 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                </div>
            </div>
            <div _tmplitem="22" v-if="readDataPermission.imgydk2" class="bigitem imgydk2 " style="top: 570px; left: 840px;position: absolute; width: 15px; height: 15px; transform: translate(0px, 0px); z-index: 1010;pointer-events: auto;  ">
                <div _tmplitem="22" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <bigimg _tmplitem="12" :url="$staticUrl('/statics/2025/09/13/login_select_20250913170723A071.png')" w="15" h="15" rotatetype="" rotatetime="" @click="readDataPermission.imgydk2 = false"></bigimg>
                </div>
            </div>
            <div _tmplitem="22" v-else class="bigitem imggak4 " style="top: 570px; left: 840px;position: absolute; width: 15px; height: 15px; transform: translate(0px, 0px); z-index: 109;pointer-events: auto;  ">
                <div _tmplitem="22" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <bigimg _tmplitem="13" :url="$staticUrl('/statics/2025/09/13/login_select_no_20250913170539A070.png')" w="15" h="15" rotatetype="" rotatetime="" @click="readDataPermission.imgydk2 = true"></bigimg>
                </div>
            </div>
            <div _tmplitem="22" v-if="readDataPermission.buttonrwn2" class="bigitem buttonrwn2 " style="top: 610px; left: 840px;position: absolute; width: 230px; height: 40px; transform: translate(0px, 0px); z-index: 108;pointer-events: auto;  ">
                <div _tmplitem="22" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:14px ;color:#FFF ;background-color:#007387;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <el-button type="primary" @click="getLogin" size="mini" icon="" class="bigbutton" style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:14px ;color:#FFF ;background-color:#007387;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">用户登录</el-button>
                </div>
            </div>
            <div _tmplitem="22" v-if="readDataPermission.forminputlw31" class="bigitem forminputlw31 " style="top: 510px; left: 840px;position: absolute; width: 240px; height: 40px; transform: translate(0px, 0px); z-index: 107;pointer-events: auto;  ">
                <div _tmplitem="22" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:14px ;color:#4DBAC9 ;border: 1px solid #1CACC6 ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <el-input v-model="fromData.forminputlw31" placeholder="请输入密码" show-password clearable type="password" prefix-icon="" suffix-icon="" class="custom-placeholder-input" style="height: 40px;line-height: 40px; color: #4DBAC9;background-color: rgba(255,255,255 0);"></el-input>
                </div>
            </div>
            <div _tmplitem="22" v-if="readDataPermission.forminput0d9u" class="bigitem forminput0d9u " style="top: 440px; left: 840px;position: absolute; width: 240px; height: 40px; transform: translate(0px, 0px); z-index: 106;pointer-events: auto;  ">
                <div _tmplitem="22" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:14px ;color:#4DBAC9 ;border: 1px solid #1CACC6 ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <el-input v-model="fromData.forminput0d9u" placeholder="请输入账号" clearable type="text" prefix-icon="" suffix-icon="" class="custom-placeholder-input" style="height: 40px;line-height: 40px; color: #4DBAC9;background-color: rgba(255,255,255 0);"></el-input>
                </div>
            </div>
            <div _tmplitem="22" v-if="readDataPermission.titleb1vf" class="bigitem titleb1vf " style="top: 317px; left: 910px;position: absolute; width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 105;pointer-events: auto;  ">
                <div _tmplitem="22" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:24px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:center;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <titlecontrol _tmplitem="17" ref="titleb1vf" :w="100" :h="40" :val="fromData.titleb1vf" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:24px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:center;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                </div>
            </div>
            <div _tmplitem="22" v-if="readDataPermission.titlever4" class="bigitem titlever4 " style="top: 900px; left: 611px;position: absolute; width: 698px; height: 38px; transform: translate(0px, 0px); z-index: 104;pointer-events: auto;  ">
                <div _tmplitem="22" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:24px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <titlecontrol _tmplitem="18" ref="titlever4" :w="698" :h="38" :val="fromData.titlever4" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:24px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);background: linear-gradient(180deg, #E6ECFF 0%, #7CE6DD 100%); -webkit-background-clip: text; background-clip: text;-webkit-text-fill-color: transparent;text-fill-color: transparent;"></titlecontrol>
                </div>
            </div>
            <div _tmplitem="22" v-if="readDataPermission.titlew0f7" class="bigitem titlew0f7 " style="top: 850px; left: 711px;position: absolute; width: 500px; height: 40px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
                <div _tmplitem="22" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:34px ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:center;font-weight:bolder ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <titlecontrol _tmplitem="19" ref="titlew0f7" :w="500" :h="40" :val="fromData.titlew0f7" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:34px ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:center;font-weight:bolder ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);background: linear-gradient(180deg, #E6ECFF 0%, #0EE0D4 100%);font-weight: bolder; -webkit-background-clip: text; background-clip: text;-webkit-text-fill-color: transparent;text-fill-color: transparent;font-style: italic;"></titlecontrol>
                </div>
            </div>
            <div _tmplitem="22" v-if="readDataPermission.imgfg8o" class="bigitem imgfg8o " style="top: 290px; left: 660px;position: absolute; width: 600px; height: 500px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
                <div _tmplitem="22" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <bigimg _tmplitem="20" :url="$staticUrl('/statics/2025/09/13/login_bg1_20250913161558A066.png')" w="600" h="500" rotatetype="" rotatetime=""></bigimg>
                </div>
            </div>
            <div _tmplitem="22" v-if="readDataPermission.imgaog9" class="bigitem imgaog9 " style="top: 0px; left: -5px;position: absolute; width: 1946px; height: 1083px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
                <div _tmplitem="22" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <bigimg _tmplitem="21" :url="$staticUrl('/statics/2025/09/13/login_bg_20250913161329A065.png')" w="1946" h="1083" rotatetype="" rotatetime=""></bigimg>
                </div>
            </div>
        </div>
        <!-- <fromdialog _tmplitem="22" ref="reffromdialog"></fromdialog> -->
    </div>
</template>
<script>
import { getLogin } from '@/api/system'
import { setUserPassword , getUserPassword , setToken, setSidkey } from '@/utils/auth'
import { Message } from 'element-ui'
import screenAdapter from '@/mixins/screenAdapter.js'
    export default {
        mixins: [screenAdapter],
        methods: {
            getLogin() {
                getLogin({
                    userType: 'ESTATE_USER',
                    username: this.fromData.forminput0d9u,
                    password: this.fromData.forminputlw31
                }).then(res => {
                    if(res.code == 200){
                        setToken(res.data.access_token)
                        setSidkey(res.data.access_token)
                        if (this.readDataPermission.imgydk2 == true) {
                            var user = {
                                username: this.fromData.forminputlw31,
                                password: this.fromData.forminput0d9u
                            }
                            const encodedUser = btoa(JSON.stringify(user))
                            setUserPassword(encodedUser)
                        }else {
                            setUserPassword('')
                        }
                        Message.success('登录成功！');
                        window.open(this.redirect, '_self')
                    }
                })
            },
            created_sys() {
                ///系统方法 判断页面大小 使其自动适应
                let $this = this
                this.w = this.w === undefined ? 1920 : this.w
                $this.css = $this.fullScreenCss($this, this.screentype)
                window.addEventListener('resize', () => {
                    $this.css = $this.fullScreenCss($this, this.screentype)
                })
                if (this.loadfunmounted_sys !== undefined) {
                    this.$nextTick(() => {
                        this.loadfunmounted_sys()
                    })
                }
            },
            imgzdxx_click() {},
            loadsysmounted() {}
        },
        created() {
            this.redirect = this.$route.query.redirect;
            this.created_sys();
            let userData = getUserPassword()
            if (userData !== '' && userData !== undefined && userData !== 'undefined') {
                try {
                    // 解码Base64并解析为JSON对象
                    const decodedUser = JSON.parse(atob(userData))
                    this.fromData.forminputlw31 = decodedUser.username
                    this.fromData.forminput0d9u = decodedUser.password
                } catch (e) {
                    console.error('解析用户数据失败', e)
                }
            }
            if (this.loadfunmounted !== undefined) {
                this.$nextTick(() => {
                    this.loadfunmounted();
                });
            }
        },
        data() {
            return {
                redirect: '',

                w: 1920,
                css: ``,
                h: 1080,
                bg: ``,
                bgColor: `rgb(43 44 45)`,
                fromData: {
                    titletasx: `记住密码`,
                    forminputlw31: ``,
                    forminput0d9u: ``,
                    titleb1vf: `系统登录`,
                    titlever4: `Zhongyun Urban Management Situation Awareness System`,
                    titlew0f7: `中耘城市管理 态势感知系统`
                },
                controlTimer: {},
                controlData: {},
                screentype: `full`,
                readDataPermission: {
                    img0kl8: true,
                    titletasx: true,
                    imgydk2: false,
                    buttonrwn2: true,
                    forminputlw31: true,
                    forminput0d9u: true,
                    titleb1vf: true,
                    titlever4: true,
                    titlew0f7: true,
                    imgfg8o: true,
                    imgaog9: true
                }
            }
        },
        components: {}
    }
</script>
<style scoped>
    .custom-placeholder-input /deep/ input::placeholder {
        color: #4DBAC9;
    }
    .dv-full-screen-container {
        transform: scale(1);
        position: absolute;
        top: 0px;
        left: 0px;
        overflow: hidden;
        transform-origin: left top;
        z-index: 499;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        width: 1920px;
        height: 1080px;
        background-color: '#040404';
        background-size: cover;
        background-repeat: no-repeat;
    }

    .div-full-screen {
        background-size: cover;
        background-repeat: no-repeat;
    }

    .bigitem {
        position: absolute;
        will-change: transform;
    }

    .bigechartitem:hover {
        z-index: 1900 !important;
    }

    .layouttable {
        height: 100%;
        display: flex;
    }

    .layouttable .layouttable-item {
        height: 100%;
        position: relative;
        float: left;
    }

    .itemcontent {
        width: 100%;
        height: 100%;
    }

    .bigbutton {
        width: 100%;
        height: 100%;
        text-align: center;
    }
</style>
<style scoped></style>